module.exports = __webpack_public_path__ + "media/images/top/etc-card-5-c65994b7ba4dffae9720e54b7a8af732.jpg";